<script setup lang="ts">
    import ViewControlsCluster from '@/views/3d-planner/view-controls/components/ViewControlsCluster.vue';
    import AdjustmentsMeasurements from '@/views/3d-planner/measurements/components/AdjustmentsMeasurements.vue';
    import PlannerSidebar from '@/views/3d-planner/components/planner-sidebar/PlannerSidebar.vue';
    import CtSliderRow from '@/views/3d-planner/view-controls/components/CtSliderRow.vue';
    import { useVersion } from '@/stores/version';
    import { PLANNER_TARGETS } from '@/domain/analytics/analyticsTargets';

    const versionStore = useVersion();
</script>

<template>
    <div class="planner-overlay">
        <slot />

        <div class="top-section">
            <PlannerSidebar />

            <div
                class="top-right-container"
                :data-analytics-id="PLANNER_TARGETS.plannerMeasurements"
            >
                <adjustments-measurements />
            </div>

            <div class="version-label">
                {{ versionStore.versionWithPrefix }}
            </div>
        </div>

        <div class="bottom-section">
            <CtSliderRow />
            <view-controls-cluster />
        </div>
    </div>
</template>

<!--suppress CssUnusedSymbol -->
<style scoped lang="scss">
    .planner-overlay {
        position: relative;
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;
        // Match the 3D canvas clear-colour so any sliver between the canvas
        // and the bar reveals the right shade.
        background: rgb(var(--v-theme-scene-background));
    }

    // Top section absorbs all leftover space above the bottom section. Sits
    // above the absolutely-positioned canvas via `position: relative`.
    // Pointer-events: none lets clicks in empty regions reach the canvas;
    // interactive children opt back in.
    .top-section {
        position: relative;
        flex: 1;
        min-height: 0;
        pointer-events: none;

        > * {
            pointer-events: auto;
        }
    }

    .top-right-container {
        position: absolute;
        top: 0;
        right: 0;
        margin: 20px;
        width: 400px;
    }

    .version-label {
        position: absolute;
        bottom: 8px;
        left: 64px; // 56px rail + 8px gap to the right — matches vertical gap
        font-size: 0.75rem;
        line-height: 1.25rem;
        font-weight: 500;
        color: rgb(var(--v-theme-secondary));
        pointer-events: none;
        white-space: nowrap;
    }

    .bottom-section {
        position: relative;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
    }
</style>
